import React from 'react'
import { Link } from 'react-router-dom'
import { TrainingModule, TrainingModuleMetaProps } from '../data/types'
import {
    AudioIcon,
    ClockIcon,
    DocumentIcon,
    ExternalLinkIcon,
    InteractiveIcon,
    ConstructionIcon,
    QuizIcon,
    VideoIcon,
} from '../icons'

type Props = {
    module: TrainingModule,
    moduleLink: string
    meta: TrainingModuleMetaProps
}




const getModuleIcon = (type: string, className?: string) => {
    switch (type) {
        case 'video':
            return <VideoIcon className={className} />
        case 'document':
            return <DocumentIcon className={className} />
        case 'audio':
            return <AudioIcon className={className} />
        case 'quiz':
            return <QuizIcon className={className} />
        case 'interactive':
            return <InteractiveIcon className={className} />
        case 'external':
            return <ExternalLinkIcon className={className} />
        case 'coming_soon':
            return <ConstructionIcon className={className} />
        default:
            return <DocumentIcon className={className} />
    }
}

export const ModuleCard = ({ module, moduleLink, meta }: Props) => {

    const isComingSoon = module.type === 'coming_soon'

    const cardContent = (
        <div className={`p-4 bg-gray-100 dark:bg-gray-700/50 rounded-lg flex items-center justify-between ${!isComingSoon ? 'hover:bg-gray-200 dark:hover:bg-gray-600' : 'opacity-60 cursor-not-allowed'} transition-colors`}>
            {/* Icon */}
            <div className="flex items-center gap-4">
                <div className={`${isComingSoon ? 'text-gray-400 dark:text-gray-500' : 'text-primary-600 dark:text-primary-400'}`}>
                    {getModuleIcon(module.type, "w-6 h-6")}
                </div>

                {/* Module title (optional if you want to add later) */}
                <div className={`font-medium ${isComingSoon ? 'text-gray-500 dark:text-gray-400' : 'text-gray-800 dark:text-gray-200'}`}>
                    {module.title}
                </div>
            </div>

            {/* Duration on far right */}
            {module?.duration && (
                <div className="flex items-center gap-2 text-gray-600 dark:text-gray-400">
                    <ClockIcon className="w-5 h-5" />
                    <span className="text-sm whitespace-nowrap">
                        {module.duration} {meta.minutesSuffix}
                    </span>
                </div>
            )}
        </div>
    )

    if (isComingSoon) {
        return <div className="block">{cardContent}</div>
    }

    return (
        <Link
            to={moduleLink}
            className="block"
        >
            {cardContent}
        </Link>
    );
};

